import { george, helpers, pr, theme } from "aaa";
import { ui } from "components/util/uiHelpers";
import { FormattedHTMLMessage } from "i18n/util";
import { observer } from "mobx-react";
import { GenericAPIClient } from "network/APIClient";
import * as React from "react";
import { pushRoute } from "stores/RouterFunctions";
import { b64ToBlob, b64ToUint8 } from "util/helpers";
import externalInterfaceStore from "../../stores/ExternalInterfaceStore";
import { ActionButton } from "../common/georgeComponents";
import { GooglePayRoutes } from "./GooglePayRoutes";
import { GooglePayStore } from "./GooglePayStore";
import * as FileSaver from "file-saver";
import { GenericDocument } from "types/documents";

type IProps = {
    store: GooglePayStore
};

export const GooglePayPersonalData = observer(({ store }: IProps) => {
    if (store.isLoading) {
        return <george.LoadingIndicator isLoading height={ui.windowHeight} />;
    }

    const handleDownload = async (url: string, title: string) => {
        try {
            const response = await GenericAPIClient.requestType<GenericDocument>({
                // For local testing we replace the https:// prefix with our proxy url
                url: url.replace("https://", ""),
                method: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/x-www-form-urlencoded"
                },
                parse: json => json as GenericDocument
            });

            if (atob(response.content).slice(0, 1025).includes("%PDF-")) {
                if (helpers.isAndroid() || helpers.isIos()) {
                    store.pdfData = b64ToUint8(response.content);
                    pushRoute(GooglePayRoutes.PDF);
                } else {
                    const blob = b64ToBlob(response.content, "application/pdf");
                    FileSaver.saveAs(blob, title);
                }
            }
        } catch (error) {
            pushRoute("/error");
        }
    };

    const PageComponent = externalInterfaceStore.isGeorgeApp ? george.PageWithActionButton : React.Fragment;

    const document = store.approvalResponse?._links?.approvalDocument;

    return (
        <george.Background>
            <PageComponent>
                <george.Card style={{ marginBottom: theme.MARGIN_SMALL }}>
                    <pr.A11yPopupHider>
                        <div style={{ padding: theme.MARGIN }}>
                            <pr.P_16_TITLE style={{ fontWeight: "bold" }}>
                                {ui.__("googlePay.personalData.approval.title")}
                            </pr.P_16_TITLE>
                            <pr.P_16_CONTENT style={{ marginTop: theme.MARGIN_SMALL }}>
                                {ui.__("googlePay.personalData.approval.text")}
                            </pr.P_16_CONTENT>
                            <pr.P_16_TITLE style={{ fontWeight: "bold", marginTop: theme.MARGIN }}>
                                {ui.__("googlePay.personalData.data.title")}
                            </pr.P_16_TITLE>
                            <pr.P_16_CONTENT style={{ marginTop: theme.MARGIN_SMALL }}>
                                <FormattedHTMLMessage id="googlePay.personalData.data.text" />
                            </pr.P_16_CONTENT>
                            <pr.P_16_CONTENT>
                                <FormattedHTMLMessage id="googlePay.personalData.data.types.list" />
                            </pr.P_16_CONTENT>
                            <pr.P_16_CONTENT>
                                <FormattedHTMLMessage id="googlePay.personalData.data.usage.title" />
                            </pr.P_16_CONTENT>
                            <pr.P_16_CONTENT>
                                <FormattedHTMLMessage id="googlePay.personalData.data.usage.list" />
                            </pr.P_16_CONTENT>
                            <pr.P_16_CONTENT>
                                {ui.__("googlePay.personalData.cancellation")}
                            </pr.P_16_CONTENT>
                            {document?.href && (
                                <div
                                    role="button"
                                    onClick={() => handleDownload(document?.href, document.title)}
                                    className="theme-secondary-action-label-color"
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        fontWeight: 600,
                                        fontSize: 14,
                                        cursor: "pointer",
                                        marginTop: theme.MARGIN,
                                    }}
                                >
                                    <pr.IconDownload style={{ marginRight: 5 }} />
                                    <span>{document.title}</span>
                                </div>
                            )}
                        </div>
                        {!externalInterfaceStore.isGeorgeApp &&
                            <pr.LightSeparatorLine spacing={theme.MARGIN} />
                        }
                        <ActionButton
                            primary
                            messageId="googlePay.personalData.submit"
                            onClick={() => {
                                pushRoute(GooglePayRoutes.SUMMARY);
                            }}
                            {...george.getActionButtonWebVersionProps()}
                        />
                    </pr.A11yPopupHider>
                </george.Card>
            </PageComponent>
        </george.Background>
    );
});



// WEBPACK FOOTER //
// ./src/components/googlePay/GooglePayPersonalData.tsx